export default class Store {
    constructor() {
        this.data = {};
    }

    set(key, value) {
        if(key && key.length) {
            this.data[key] = value;
        }else {
            console.warn(`The key is empty!`);
        }
    }

    get(key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    }

    all() {
        return this.data;
    }
}